import { SkyscannerFenryrServiceV1PriceCalendarExplore } from '@skyscanner-internal/fenryr-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import { jhaMiddleware } from '../internals/clients/grpc/jhaMiddleware';

import type { SkyscannerFenryrModelV1PriceCalendarExplore } from '@skyscanner-internal/fenryr-web-http-client';

type PriceCalendarExploreRequest =
  SkyscannerFenryrModelV1PriceCalendarExplore.PriceCalendarExploreRequest;
type PriceCalendarExploreResponse =
  SkyscannerFenryrModelV1PriceCalendarExplore.PriceCalendarExploreResponse;

export const GRPC_PRICE_CALENDAR_EXPLORE_CLIENT_NAME = 'FENRYR_PRICE_CALENDAR_EXPLORE';

export const fenryrPriceCalendarExploreRequest = grpcFetchClientWrapper<
  PriceCalendarExploreRequest,
  PriceCalendarExploreResponse
>(SkyscannerFenryrServiceV1PriceCalendarExplore.PriceCalendarExploreService.PriceCalendarExplore, {
  clientName: GRPC_PRICE_CALENDAR_EXPLORE_CLIENT_NAME,
  pathPrefix: '/g/search-intent',
  betaInterceptors: [jhaMiddleware],
});
